export enum LoggerUpdateFirmwareType {
  Differential = 'DIFFERENTIAL',
  Full = 'FULL',
}
